import { getRegenerateToken } from "../../redux/actions/regenerateTokenAction";

const regenerateToken = (dispatch, authToken, partnerId) => {
    // console.log("authToken received before", authToken);
    dispatch(getRegenerateToken({
        authentication: {
            partnerId: partnerId || localStorage.getItem("walletOwnerId"),
        },
        authToken: authToken,
    }));
    sessionStorage.setItem("walletOwnerId",partnerId)

}

export default regenerateToken   